// assets/typesense-actions.js
(function () {
  "use strict";

  // Your real section handles
  const CART_DRAWER_HANDLE = "sections--21187295477985__cart-drawer";
  const HEADER_HANDLE = "sections--21187295445217__header";

  // Results containers (only block form submits in these)
  const TYPESENSE_RESULTS_ROOT_SELECTORS = [
    "#typesense-results",
    ".typesense-results",
    "#typesense-search-results",
    ".typesense-search-results",
    '[data-typesense-results]',
    '#shopify-section-template--21187303735521__typesense_search_results_Qy4a6f'
  ];

  function getTypesenseRoot(el) {
    if (!el) return null;
    for (const sel of TYPESENSE_RESULTS_ROOT_SELECTORS) {
      const root = el.closest(sel);
      if (root) return root;
    }
    return null;
  }

  // ✅ ENHANCED: Block ALL form submits inside Typesense results with stronger prevention
  document.addEventListener(
    "submit",
    (e) => {
      const form = e.target;
      if (!form || form.nodeType !== 1) return;
      
      // Check if this is inside Typesense results
      if (!getTypesenseRoot(form)) return;

      console.log('Typesense: Blocking form submit in results area');
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      
      // Also prevent any default action that might be triggered
      if (e.defaultPrevented) return;
      
      return false;
    },
    true // Use capturing phase to catch early
  );

  // ✅ NEW: Also intercept click events on submit buttons in Typesense results
  document.addEventListener(
    "click",
    (e) => {
      // Find the clicked button
      let target = e.target;
      if (target.tagName !== 'BUTTON') {
        target = target.closest('button');
      }
      
      if (!target) return;
      
      // Check if it's a submit button inside Typesense results
      const isSubmitButton = target.type === 'submit' || 
                            target.getAttribute('type') === 'submit' ||
                            target.closest('form') ||
                            target.hasAttribute('data-add-to-cart') ||
                            target.classList.contains('add-to-cart');
      
      if (!isSubmitButton) return;
      
      // Check if inside Typesense results
      if (!getTypesenseRoot(target)) return;
      
      console.log('Typesense: Blocking button click that might navigate');
      
      // For add-to-cart buttons specifically, we already handle them via window.addToCart
      // So we just need to prevent default navigation
      const form = target.closest('form');
      if (form && (form.action.includes('/cart') || form.action.includes('/cart/add'))) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    },
    true // Use capturing phase
  );

  // ✅ NEW: Intercept any navigation attempts from Typesense results
  const originalAddEventListener = EventTarget.prototype.addEventListener;
  EventTarget.prototype.addEventListener = function(type, listener, options) {
    // Intercept click events on elements that might navigate
    if (type === 'click' && this instanceof Element) {
      const wrappedListener = function(e) {
        // Check if this element is inside Typesense results
        if (getTypesenseRoot(this)) {
          // Check if this might trigger navigation
          const href = this.getAttribute('href');
          const form = this.closest('form');
          if (href && href.includes('/cart') || 
              (form && (form.action.includes('/cart') || form.action.includes('/cart/add')))) {
            console.log('Typesense: Intercepted potential navigation to cart');
            e.preventDefault();
            e.stopImmediatePropagation();
            return;
          }
        }
        return listener.call(this, e);
      };
      return originalAddEventListener.call(this, type, wrappedListener, options);
    }
    return originalAddEventListener.call(this, type, listener, options);
  };

  // -------------------------
  // Helper: Escape HTML
  // -------------------------
  function escapeHtml(s) {
    return String(s || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  // -------------------------
  // Toast / message helper
  // -------------------------
  window.showMessage = function (message, type = "info") {
    let messageContainer = document.getElementById("ts-message-container");
    if (!messageContainer) {
      messageContainer = document.createElement("div");
      messageContainer.id = "ts-message-container";
      messageContainer.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        z-index: 999999;
        display: flex;
        flex-direction: column;
        gap: 10px;
        max-width: 320px;
      `;
      document.body.appendChild(messageContainer);
    }

    const bg =
      type === "success" ? "#4CAF50" : type === "error" ? "#f44336" : "#FF9800";

    const messageEl = document.createElement("div");
    messageEl.style.cssText = `
      background: ${bg};
      color: white;
      padding: 12px 16px;
      border-radius: 8px;
      box-shadow: 0 6px 16px rgba(0,0,0,0.25);
      animation: tsSlideIn 0.25s ease;
      font-weight: 600;
      font-size: 14px;
      line-height: 1.3;
    `;
    messageEl.textContent = message;
    messageContainer.appendChild(messageEl);

    setTimeout(() => {
      messageEl.style.animation = "tsSlideOut 0.25s ease";
      setTimeout(() => {
        messageEl.remove();
        if (messageContainer && messageContainer.children.length === 0) {
          messageContainer.remove();
        }
      }, 250);
    }, 2500);
  };

  // CSS once
  if (!document.getElementById("ts-message-styles")) {
    const styleEl = document.createElement("style");
    styleEl.id = "ts-message-styles";
    styleEl.textContent = `
      @keyframes tsSlideIn { from { transform: translateX(16px); opacity: 0; } to { transform: translateX(0); opacity: 1; } }
      @keyframes tsSlideOut { from { transform: translateX(0); opacity: 1; } to { transform: translateX(16px); opacity: 0; } }
      .ts-spinner-small {
        display:inline-block;
        width:16px;height:16px;
        border:2px solid rgba(255,255,255,.35);
        border-radius:50%;
        border-top-color:#fff;
        animation: tsSpin .7s linear infinite;
        vertical-align: middle;
      }
      @keyframes tsSpin { to { transform: rotate(360deg); } }
    `;
    document.head.appendChild(styleEl);
  }

  // -------------------------
  // Cart helpers
  // -------------------------
  function updateCartCount(newCount) {
    const selectors = [
      ".cart-count",
      ".js-cart-count",
      ".site-header__cart-count",
      "#CartCount",
      "[data-cart-count]",
      ".header__cart-count",
      ".cart-badge",
      ".cart-item-count",
      ".cart-bubble",
      ".cart-count-bubble span",
      ".cart-link__bubble-num",
    ];

    selectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((el) => {
        el.textContent = String(newCount);
        if (el.hasAttribute("data-cart-count")) {
          el.setAttribute("data-cart-count", String(newCount));
        }
      });
    });

    // Show/hide bubble wrapper if theme uses one
    document.querySelectorAll(".cart-count-bubble").forEach((bubble) => {
      bubble.style.display = newCount > 0 ? "inline-flex" : "none";
    });
  }

  async function fetchCart() {
    const r = await fetch("/cart.js", { credentials: "same-origin" });
    if (!r.ok) throw new Error("Failed to fetch /cart.js");
    return r.json();
  }

  function fireThemeCartEvents(cart) {
    try {
      document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true, detail: cart }));
      document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: cart }));
      document.dispatchEvent(new Event("cart:update"));
      window.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));
    } catch (_) {}
  }

  // ✅ Refresh sections WITHOUT shopify:section:load (prevents "already exists")
  async function refreshExactSections(handles) {
    const url = `/?sections=${encodeURIComponent(handles.join(","))}`;
    const r = await fetch(url, { credentials: "same-origin" });
    if (!r.ok) return false;

    const sections = await r.json().catch(() => null);
    if (!sections) return false;

    Object.keys(sections).forEach((handle) => {
      const html = sections[handle];
      const container = document.getElementById(`shopify-section-${handle}`);
      if (container && typeof html === "string") {
        container.innerHTML = html;
      }
    });

    return true;
  }

  async function refreshCartCountOnly() {
    const cart = await fetchCart();
    updateCartCount(cart.item_count);
    fireThemeCartEvents(cart);
    return cart;
  }

  async function refreshCartDrawerAndHeader() {
    const cart = await fetchCart();
    updateCartCount(cart.item_count);
    fireThemeCartEvents(cart);

    // Only refresh drawer+header when we truly need it (after add-to-cart)
    await refreshExactSections([HEADER_HANDLE, CART_DRAWER_HANDLE]);
    return cart;
  }

  // Open cart drawer by clicking the header cart button
  function openDrawerByClickingHeaderCart() {
    const btn =
      document.querySelector('[data-cart-drawer-toggle]') ||
      document.querySelector('[aria-controls*="cart" i]') ||
      document.querySelector('button[aria-label*="cart" i]') ||
      document.querySelector('[data-cart-toggle]') ||
      document.querySelector('.header__icon--cart');

    if (btn) {
      btn.click();
      return true;
    }
    return false;
  }

  // -------------------------
  // ✅ ENHANCED ADD TO CART (does NOT redirect to /cart)
  // -------------------------
  window.addToCart = async function (variantId, buttonElement, qty = 1) {
    if (!variantId) {
      window.showMessage("This product is not available for purchase.", "error");
      return false;
    }

    // Prevent any default behavior MORE aggressively
    if (buttonElement && buttonElement.nodeType === 1) {
      try { 
        // Change button type to prevent form submission
        if (buttonElement.form) {
          buttonElement.setAttribute("formnovalidate", "true");
        }
        buttonElement.setAttribute("type", "button"); 
        buttonElement.dataset.originalText = buttonElement.textContent;
        
        // Remove any href that might cause navigation
        if (buttonElement.hasAttribute('href')) {
          buttonElement.dataset.originalHref = buttonElement.getAttribute('href');
          buttonElement.removeAttribute('href');
        }
        
        // Remove any onclick that might navigate
        const originalOnClick = buttonElement.getAttribute('onclick');
        if (originalOnClick && originalOnClick.includes('window.location') || originalOnClick.includes('/cart')) {
          buttonElement.dataset.originalOnClick = originalOnClick;
          buttonElement.removeAttribute('onclick');
        }
      } catch (_) {}
    }

    const originalHTML = buttonElement ? buttonElement.innerHTML : "";
    if (buttonElement) {
      buttonElement.innerHTML = `<span class="ts-spinner-small"></span> Adding…`;
      buttonElement.disabled = true;
      buttonElement.classList.remove("success");
    }

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { 
          "Content-Type": "application/json",
          "Accept": "application/json" 
        },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(qty) || 1 }] }),
      });

      // Handle Shopify errors (422 = sold out, etc.)
      const payload = await res.json().catch(() => ({}));

      if (!res.ok) {
        const msg =
          payload?.description ||
          payload?.message ||
          payload?.status ||
          `Add to cart failed (${res.status})`;
        throw new Error(msg);
      }

      // ✅ Update cart count only (no page redirect)
      const cart = await refreshCartDrawerAndHeader();
      setTimeout(() => refreshCartDrawerAndHeader().catch(() => {}), 200);

      // ✅ OPTIONAL: Try to open drawer (but DON'T navigate to /cart)
      // Only if your theme has a drawer. Comment out if it navigates instead.
      // setTimeout(() => openDrawerByClickingHeaderCart(), 50);

      if (buttonElement) {
        buttonElement.classList.add("success");
        buttonElement.innerHTML = "✓ Added!";
        setTimeout(() => {
          buttonElement.classList.remove("success");
          buttonElement.innerHTML = originalHTML || "Add to Cart";
          buttonElement.disabled = false;
          
          // Restore original attributes if they existed
          if (buttonElement.dataset.originalHref) {
            buttonElement.setAttribute('href', buttonElement.dataset.originalHref);
            delete buttonElement.dataset.originalHref;
          }
          if (buttonElement.dataset.originalOnClick) {
            buttonElement.setAttribute('onclick', buttonElement.dataset.originalOnClick);
            delete buttonElement.dataset.originalOnClick;
          }
        }, 1200);
      }

      window.showMessage("Product added to cart!", "success");
      return cart;
    } catch (err) {
      console.error("addToCart error:", err);
      if (buttonElement) {
        buttonElement.innerHTML = originalHTML || "Add to Cart";
        buttonElement.disabled = false;
        
        // Restore original attributes
        if (buttonElement.dataset.originalHref) {
          buttonElement.setAttribute('href', buttonElement.dataset.originalHref);
          delete buttonElement.dataset.originalHref;
        }
        if (buttonElement.dataset.originalOnClick) {
          buttonElement.setAttribute('onclick', buttonElement.dataset.originalOnClick);
          delete buttonElement.dataset.originalOnClick;
        }
      }
      window.showMessage(escapeHtml(err.message || "Error adding to cart. Please try again."), "error");
      return false;
    }
  };

  // -------------------------
  // ADD TO WISHLIST (global)
  // -------------------------
  window.addToWishlist = function (productId, productHandle, productTitle, buttonElement) {
    if (buttonElement && buttonElement.nodeType === 1) {
      try { buttonElement.setAttribute("type", "button"); } catch (_) {}
    }

    if (typeof window.Swish === "object" && typeof window.Swish.addProduct === "function") {
      window.Swish.addProduct(productId, productHandle, productTitle);
      window.showMessage("Added to wishlist!", "success");
      return;
    }

    window.showMessage("Wishlist is still loading. Try again in a second.", "info");
  };

  // ✅ On normal page load: ONLY update count (do NOT rebuild cart drawer section)
  document.addEventListener("DOMContentLoaded", () => {
    refreshCartCountOnly().catch(() => {});
  });

  // ✅ NEW: Global event listener to catch any attempts to navigate to /cart from Typesense results
  window.addEventListener('beforeunload', function(e) {
    // Check if we're trying to navigate to cart from Typesense results
    const activeElement = document.activeElement;
    if (activeElement && getTypesenseRoot(activeElement)) {
      const href = activeElement.href || activeElement.getAttribute('href') || '';
      if (href.includes('/cart')) {
        console.log('Typesense: Preventing navigation to cart from results');
        e.preventDefault();
        return false;
      }
    }
  });
})();